<template lang="pug">
  div.account.user-profile.section.section--border.user-page
    div(v-show="tabView == 'tab1'").section-wrapper
      e-form(
        :formValidator="formValidator"
        :enablePerfectScrollbar="false"
      ).body-wrapper.user
        //div.body-wrapper.user
        div.body.profile
          div.user-info
            div.user-info__photo
              div(v-if="userPhoto").user-info__photo-img
                img(:src="userPhoto")
              div(v-else).user-info__photo-img
                img(src="~img/user-img-default.svg")
              div.file-upload
                label(for="upload").user-info__photo-edit Изменить фото
                input(type="file" @change="onChangePhoto").file-upload__input
              //input(type="file").user-info__photo-edit
              //button.user-info__photo-edit Изменить фото
            div.user-info__full
              div.user-name
                div.user-surname &nbsp;
                span.user-fullname {{fields.fullname ? fields.fullname : 'Имя не указано'}}
              div(v-if="fields.role_description").user-post {{fields.role_description}}
              div.user-email {{fields.email}}

        div.body
          div.col
            e-form-subtitle(text="Место работы")

            e-form-group(
              name="organization"
              inputType="input"
              label="Организация"
              :model="fields"
              tabView="tab1"
            )
            e-form-group(
            name="position"
            inputType="input"
            label="Должность"
              :model="fields"
            tabView="tab1"
            )
            e-form-group(
            name="phone"
            inputType="input"
            label="Рабочий телефон / Skype"
              :model="fields"
            tabView="tab1"
            )
            div.col-block
              button(@click="logout()").user-button.user-button--warning Выйти


          div.col
            e-form-subtitle(text="Личные данные")

            e-form-group(
            name="birth_date"
            inputType="calendar"
            label="Дата рождения"
              placeholder="дд.мм.гггг"
              :model="fields"
            tabView="tab1"
            )
            e-form-group(
            name="email"
            inputType="input"
            label="E-mail"
              :model="fields"
            tabView="tab1"
              validationRule="email"
              :required="true"
              :disabled="true"
            )
            e-form-group(
            name="mobile_phone"
            inputType="input"
            label="Мобильный телефон"
              :model="fields"
            tabView="tab1"
            mask="+7(###) ###-##-##"
            )
            div.col-block.buttons
              button(
                @click="saveTab()"
                :disabled="formFreezed"
              ).user-button.user-button--save {{formFreezed ? 'Сохранение' : 'Сохранить'}}

          div.col


    div(v-if="tabView == 'tab2'").section-wrapper
      e-user-files(
       :endpoint="getFilesEndpoint"
       :downloadFile="downloadFile"
      ).user

    div(v-show="tabView == 'tab4'").section-wrapper
      user-profile-change-password

</template>

<script>
  import tabsSwitcherMixin from './mixins/tabs-switcher-mixin.js'
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import UserProfileChangePassword from './components/user-profile-change-password'
  import {account, core} from '../../api/api-endpoints.js'
  import url from '../../utils/url'
  import BrowserImageManipulation from 'browser-image-manipulation'
  import {ROOT_DOMAIN} from '../../config/config'

  const IMAGE_SIZE = 300
  const IMAGE_EXT = ['jpg', 'jpeg', 'gif', 'png']
  const IMAGE_MAX_AFTER_CONVERT_SIZE = 3000000

  export default {
    components: {
      UserProfileChangePassword
    },
    mixins: [formBaseMixin, tabsSwitcherMixin],
    title: null,
    data () {
      return {
        showFilter: true,
        tabView: 'tab1',
        userPhotoConvertedImg: null,
        fields: {
          organization: '',
          photo: null
        }
      }
    },
    computed: {
      userPhoto () {
        if (this.userPhotoConvertedImg) {
          return this.userPhotoConvertedImg
        }
        if (this.fields.photo) {
          return `${ROOT_DOMAIN}${this.fields.photo}`
        }
        return null
      }
    },
    methods: {
      update () {
        if (this.item) {
          this.fields = Object.assign({}, this.item)
          // @fix: sworng server data format
          if (this.fields.birth_date) {
            if (this.fields.birth_date.indexOf('.') > -1) {
              // yyyy-MM-dd
              let tmp = this.fields.birth_date.split('.')
              if (tmp.length === 3) {
                this.fields.birth_date = `${tmp[2]}-${tmp[1]}-${tmp[0]}`
              } else {
                this.$e.errorBox('Неизвестный формат даты прислал сервер, требуется yyyy-MM-dd либо dd.MM.yyyy')
              }
            }
          }
          // @fix: server send null as string
          for (let name in this.fields) {
            if (this.fields[name] && this.fields[name] === 'null') {
              this.fields[name] = ''
            }
          }
        }
      },
      // send post for correct change status and avatar
      getStoreAction () {
        return 'createModel'
      },
      getFilesEndpoint (route) {
        return account.file(route)
      },
      downloadFile (item) {
        return {
          endpoint: core.downloadFile(item.id, 'file'),
          fileName: item.name
        }
      },
      getRedirectParams () {
        this.$bar.start()
        this.$store.dispatch('updateUserData', {ignoreCache: true}).then(r => {
          this.$bar.finish()
        }).catch(e => {
          this.$bar.finish()
        })
        return {
          name: this.$route.name,
          params: this.$route.params,
          query: this.$route.query
        }
      },
      getSaveFormOptions () {
        return {convertToFormData: true}
      },
      prepareFieldsForSend (fields) {
        let f = Object.assign({}, fields)
        if (this.uploadPhoto) {
          f.photo = this.uploadPhoto
        }
        return f
      },
      onChangePhoto (e) {
        let el = e.target || e.srcElement
        if (el && el.files && el.files[0]) {
          let file = el.files[0]
          let ext = (() => {
            let exts = file.name ? file.name.split('.') : ['']
            return exts[exts.length - 1].toLowerCase()
          })()
          if (!file.name || IMAGE_EXT.indexOf(ext) === -1) {
            this.$e.errorBox(`Измените это или выберите другое изображение.
            Для загрузки разрешены фото разрешений - ${IMAGE_EXT.join(', ')}`)
            return
          }

          this.$swal({
            title: 'Конвертация фото',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            onOpen: () => {
              this.$swal.showLoading()
            }
          })

          this.iM = new BrowserImageManipulation()
            .loadBlob(file)
            .toCircle(IMAGE_SIZE)

          this.iM.saveAsBlob().then(blob => {
            if (!blob || blob.size > IMAGE_MAX_AFTER_CONVERT_SIZE) {
              console.error(blob)
              return Promise.reject(1)
            }
            this.uploadPhoto = blob
            return this.iM.saveAsImage()
          }).then(r => {
            this.userPhotoConvertedImg = r
            this.$swal.close()
          }).catch(e => {
            this.$swal.close()
            this.$e.errorBox(`Измените это или выберите другое изображение.
            После конвертации размер превысил ${Math.round(IMAGE_MAX_AFTER_CONVERT_SIZE / 1000000)} Мб`)
          })
        }
      },
      logout () {
        this.$store.commit('userSetRedirectUrl', url.getRoute(this.$route))
        this.$store.dispatch('userLogout').then(() => {
          this.$router.push('/login')
        })
      },
      saveTab () {
        this.sendForm()
      },
      getUpdateOrCreateUrl () {
        return account.userUpdate()
      },
      getItemEndpoint (route) {
        return account.user()
      }
    },
    // TODO: prevent data duplicate loading
    asyncData ({store, route, fromRoute, methods}) {
      let promises = []
      if (methods.getItemEndpoint(route, fromRoute) !== null) {
        promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
      }

      if (promises.length === 0) {
        return Promise.resolve(1)
      }

      return Promise.all(promises)
    }
  }
</script>

<style lang="scss">
  .user-info__photo{
    .file-upload{
      position: relative;
    }
    img {
      padding: 5px;
    }
    .file-upload__input {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      font-size: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }

  .user-profile {
    .content {
      padding-bottom:0;
    }
    /*.footer-nav{*/
      /*position: relative;*/
      /*bottom: 0;*/
      /*left: 0;*/
      /*padding-top: 0;*/
      /*z-index: 90;*/
      /*background: transparent;*/
    /*}*/
    /*.paginator {*/
      /*display: flex;*/
      /*align-items: center;*/
      /*justify-content: flex-end;*/

      /*text-align: left;*/
      /*color: #8c959f;*/
      /*padding: 10px;*/
      /*input, select {*/
        /*background: transparent;*/
        /*width: auto;*/
        /*min-width: 34px;*/
        /*max-width: 60px;*/
        /*text-align: center;*/
        /*margin: 0 8px!important;*/
      /*}*/
    /*}*/
  }
</style>
